// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1SQrU","productName":"Table_productName__3SYCg"};